import { useNavigate } from 'react-router-dom';
import { FolderOpen, Gift, Globe, Heart } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

// HeaderNav — extraído de Header.jsx en P3.1 refactor (feb-2026).
// Contiene la navegación principal por iconos: Mis Apps, Referidos,
// Galería Pública, Like. Solo visible si isLoggedIn.
// JSX y clases idénticos al original.
const HeaderNav = ({
  isLoggedIn,
  liked,
  onHeartClick,
  onOpenMyApps,
  onOpenPublicGallery,
}) => {
  const navigate = useNavigate();
  const { t, language } = useLanguage();

  if (!isLoggedIn) return null;

  return (
    <div className="flex items-center gap-1">
      {/* My Apps Button */}
      <button
        onClick={onOpenMyApps}
        className="flex items-center justify-center p-1 sm:p-1.5 rounded-lg bg-zinc-800/50 hover:bg-indigo-600/20 border border-zinc-700/50 hover:border-indigo-500/40 transition-all duration-200 text-zinc-400 hover:text-indigo-400"
        title={t('gallery.myApps') || 'Mis Apps'}
        data-testid="my-apps-btn"
      >
        <FolderOpen className="w-3.5 h-3.5 sm:w-4 sm:h-4" strokeWidth={1.5} />
      </button>

      {/* Referidos — Panel aislado */}
      <button
        onClick={() => navigate('/referidos')}
        className="flex items-center justify-center p-1 sm:p-1.5 rounded-lg bg-zinc-800/50 hover:bg-amber-600/20 border border-zinc-700/50 hover:border-amber-500/40 transition-all duration-200 text-zinc-400 hover:text-amber-400"
        title={language === 'es' ? 'Panel de Referidos' : 'Referrals Panel'}
        data-testid="referidos-menu-btn"
      >
        <Gift className="w-3.5 h-3.5 sm:w-4 sm:h-4" strokeWidth={1.5} />
      </button>

      {/* Public Gallery Button */}
      <button
        onClick={onOpenPublicGallery}
        className="flex items-center justify-center p-1 sm:p-1.5 rounded-lg bg-zinc-800/50 hover:bg-purple-600/20 border border-zinc-700/50 hover:border-purple-500/40 transition-all duration-200 text-zinc-400 hover:text-purple-400"
        title={t('gallery.publicGallery') || 'Galería Pública'}
        data-testid="public-gallery-btn"
      >
        <Globe className="w-3.5 h-3.5 sm:w-4 sm:h-4" strokeWidth={1.5} />
      </button>

      {/* Heart Button - Toggle Like */}
      <button
        onClick={onHeartClick}
        className={`flex items-center gap-1 p-1 sm:px-2 sm:py-1.5 rounded-lg transition-all duration-300 ${
          liked
            ? 'bg-red-500/20 border border-red-500/40 hover:bg-red-500/30'
            : 'bg-zinc-800/50 hover:bg-zinc-700/50 border border-zinc-700/50'
        }`}
        title={liked ? t('common.unlike') : t('common.like')}
        data-testid="likes-share-btn"
      >
        <Heart
          className={`w-3.5 h-3.5 transition-all duration-300 ${
            liked ? 'text-red-500 fill-red-500 scale-110' : 'text-white hover:text-red-300'
          }`}
        />
      </button>
    </div>
  );
};

export default HeaderNav;
